import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { exportToCSV, exportToExcel, exportToPDF } from '../../ExportUtils';
import { setGlobalFilter, setItemsPerPage } from '../../Redux/slice/features/paginationSilce';
import { FaFileCsv, FaFileExcel, FaFilePdf } from "react-icons/fa";
const DataTableHeader = ({ columns, data }) => {
  const dispatch = useDispatch();
  const itemsPerPage = useSelector((state) => state.pagination.itemsPerPage);
  const globalFilter = useSelector((state) => state.pagination.globalFilter);
  const sizeOptions = [10, 25, 50, 100];
  const getDynamicFilename = (columns) => {

    const currentDate = new Date().toISOString().slice(0, 10);
    const randomNumber = Math.floor(1000 + Math.random() * 9000);
    return `Data_Export_${currentDate}_${randomNumber}`;
  };

  return (
    <div className="d-flex justify-content-end align-items-center mb-2">
      <button
        className="btn btn-secondary btn-sm me-1"
        onClick={() => exportToCSV(columns, data, getDynamicFilename(columns))}
      >
        <FaFileCsv /> CSV
      </button>

      <button
        className="btn btn-success btn-sm"
        onClick={() => exportToExcel(columns, data, getDynamicFilename(columns))}
      >
        <FaFileExcel /> Excel
      </button>
    </div>
  )
}

export default DataTableHeader